<template>
  <div
    class="agree-pill-container"
  >
    <div
      class="agreement-form"
    >
      <input
        id="agree"
        v-model="agree"
        type="checkbox"
        name="agree"
        value="agree"
        data-test="agree-checkbox"
      >
      <label for="agree">I AGREE</label>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    agree: false,
  }),
  watch: {
    agree() {
      if (this.agree) {
        this.$emit('agree-checked');
      } else {
        this.$emit('agree-unchecked');
      }
    },
  },
};
</script>

<style scoped lang="scss">

.agree-pill-container {
  display: inline-block;
}
.agreement-form {
  background-color: #006AAC;
  display: flex;
  margin-left: 1.25rem;
  padding: 0.3725rem 0.725rem;
  color: white;
  font-size: 1.25rem;
  line-height: 1.625rem;
  font-weight: 600;
  border-radius: 0.25rem;
  align-items: center;

  input {
    outline: 2px solid white;
    width: 1.1rem;
    height: 1.1rem;
  }

  label {
    margin-left: 1rem;
  }
}
</style>
